import "./contact-us-plan-info.scss"
import {FONT_COLOR, FONT_VARIANT} from "../../../../../components/fonts/font-props";
import FontHeading4 from "../../../../../components/fonts/font-heading4/font-heading4";
import FontBody1 from "../../../../../components/fonts/font-body1/font-body1";
import {IContactUs} from "../../../../../models/Plan";
import ContactUsPopup from "../../contact-us-popup/contact-us-popup";
import {useState} from "react";
import ContactUsButton from "../../contact-us-button/contact-us-button";

export interface IContactUsPlanInfo {
    contactUsPlanTitle: string;
    returnsQuota?: string;
}

const ContactUsPlanInfo: React.FC<IContactUsPlanInfo> = ({returnsQuota, contactUsPlanTitle}) => {
    const [showContactUs, setShowContactUs] = useState(false);
    return (
        <div className="contact-us-plan-info">
            <div>
                <FontHeading4 color={FONT_COLOR.PRIMARY3} variant={FONT_VARIANT.BOLD}>
                    {contactUsPlanTitle}
                </FontHeading4>
            </div>
            {returnsQuota && (
                <div>
                    <FontBody1 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>
                        {returnsQuota} {'\u00A0'}
                    </FontBody1>
                    <FontBody1 color={FONT_COLOR.PRIMARY2}>returns and above</FontBody1>
                </div>)
            }
            <div>
                <FontBody1 color={FONT_COLOR.ACCENT1} variant={[FONT_VARIANT.BOLD]}>
                    Contact our support team for any plan related question.
                </FontBody1>
            </div>
            <ContactUsButton onClick={() => setShowContactUs(true)}/>
            {showContactUs && <ContactUsPopup onCloseClicked={() => setShowContactUs(false)}/>}
        </div>
    )
};

export default ContactUsPlanInfo;
